import { create } from 'zustand';

interface FileUploadState {
  selectedFileName: string;
  uploadedFile: string;
  setSelectedFileName: (name: string) => void;
  setUploadedFile: (file: string) => void;
  resetFileUpload: () => void;
}

export const useFileUploadStore = create<FileUploadState>((set) => ({
  selectedFileName: '',
  uploadedFile: '',
  setSelectedFileName: (name: string) => set({ selectedFileName: name }),
  setUploadedFile: (file: string) => set({ uploadedFile: file }),
  resetFileUpload: () => set({ selectedFileName: '', uploadedFile: '' }),
}));
